import * as LucideIcons from 'lucide-react';
import { Check } from 'lucide-react';
import './styles/btn.css';
import { playSound } from '../utils/soundEffectHelper';
import classNames from 'classnames';

interface BtnProps {
  text: string;
  onClick: () => void;
  appendIcon?: keyof typeof LucideIcons;
  prependIcon?: keyof typeof LucideIcons;
  yellowIcon?: boolean;
  redIcon?: boolean;
  noFill?: boolean;
  xl?: boolean;
  mini?: boolean;
  anchorLink?: boolean;
  link?: string;
  isWordBox?: boolean;
  showPlayedBadge?: boolean;
  loading?: boolean;
}

function Btn(props: BtnProps) {
  const {
    text,
    onClick,
    appendIcon,
    prependIcon,
    yellowIcon,
    redIcon,
    noFill,
    xl,
    mini,
    anchorLink,
    link,
    isWordBox,
    showPlayedBadge,
    loading,
  } = props;

  const btnClass = classNames('btn', {
    'btn-xl': xl,
    'btn-mini': mini,
    'word-box-btn': isWordBox,
  });

  const iconClass = classNames('btn-icon', {
    'icon-yellow': yellowIcon,
    'icon-red': redIcon,
    'btn-icon-xl': xl,
    'btn-icon-no-fill': noFill,
  });

  const AppendIconComponent = appendIcon ? (LucideIcons[appendIcon] as React.ElementType) : null;
  const PrependIconComponent = prependIcon ? (LucideIcons[prependIcon] as React.ElementType) : null;

  const InnerContent = (
    <>
      <div className="flex justify-center gap-[6px] items-center">
        {PrependIconComponent && <PrependIconComponent className={iconClass} />}
        {text}
        {AppendIconComponent && <AppendIconComponent className={iconClass} />}
      </div>
      {showPlayedBadge && (
        <span className="check-badge">
          <Check size={12} />
        </span>
      )}
    </>
  );

  return (
    <>
      {!anchorLink && (
        <button
          className={classNames(btnClass, 'relative flex justify-center items-center', {
            'btn-loading': loading,
          })}
          onClick={() => {
            if (!loading) {
              onClick();
              playSound('btnClick');
            }
          }}
          disabled={loading}
        >
          <div className="flex items-center gap-[6px]">
            {prependIcon && PrependIconComponent && <PrependIconComponent className={iconClass} />}
            {text}
            {appendIcon && AppendIconComponent && <AppendIconComponent className={iconClass} />}
          </div>

          {showPlayedBadge && (
            <span className="check-badge">
              <Check size={12} />
            </span>
          )}
        </button>
      )}

      {anchorLink && (
        <a
          className={`${btnClass} relative`}
          onClick={() => {
            if (!loading) playSound('btnClick');
          }}
          href={link}
          target="_blank"
          rel="noreferrer"
        >
          {InnerContent}
        </a>
      )}
    </>
  );
}

export default Btn;
